"use client"
import { useVideoModal } from './VideoModalProvider'
import VideoModal from './VideoModal'

export default function GlobalVideoModal() {
  const { isOpen, closeModal, youtubeId, title } = useVideoModal()

  if (!youtubeId || !title) return null

  return (
    <VideoModal
      isOpen={isOpen}
      onClose={closeModal}
      youtubeId={youtubeId}
      title={title}
    />
  )
}
